import { render, staticRenderFns } from "./AffiliateSettings.vue?vue&type=template&id=695df4ec&scoped=true&"
import script from "./AffiliateSettings.vue?vue&type=script&lang=js&"
export * from "./AffiliateSettings.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateSettings.vue?vue&type=style&index=0&id=695df4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695df4ec",
  null
  
)

export default component.exports